/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_BOXES_YEAR } from "../graphql/getYearFilter.query";

const is = require("is_js");
const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetBoxesYearMethods extends IPluginMethodMap {
    getBoxesYear(args: any): Promise<any>;
}

export class GetBoxesYearService implements IAgentPlugin {
    readonly methods: IGetBoxesYearMethods;
    private exchangeRate: any = 1;

    constructor() {
        this.methods = {
            getBoxesYear: this.getBoxesYear.bind(this),
        };
    }

    async getBoxesYear(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                console.log(args)
                const res = await client.query({
                    query: GET_BOXES_YEAR,
                    variables: {
                        filter: {
                            user: {
                                eq: args?.id,
                            }
                        }
                    },
                    fetchPolicy: "network-only",
                });
                let year: any[] = []
                console.log(res?.data?.getBoxes?.content, is.not.empty(res?.data?.getBoxes?.content))
                if (
                    res?.data?.getBoxes?.content &&
                    is.not.empty(res?.data?.getBoxes?.content)
                ) {
                    console.log(res?.data?.getBoxes?.content)
                    const myYear = this.transformData(res?.data?.getBoxes?.content);
                    year = [...myYear];
                    console.log(year);
                }
                const uniqueData = this.removeDuplicates(year);
                uniqueData && uniqueData.length > 0 &&
                    uniqueData.sort((a: any, b: any) => b.value - a.value);
                return uniqueData;
                // return [];
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }
    private transformData = (data: any) => {
        const contentArray = data;
        return contentArray && contentArray.map((item: any) => {
            const year = parseInt(item?.presentation?.year, 10);
            return {
                label: year,
                value: year
            };
        });
    };

    private removeDuplicates = (data: any) => {
        const seen = new Set();
        return data.filter((item: any) => {
            if (seen.has(item.value)) {
                return false;
            } else {
                seen.add(item.value);
                return true;
            }
        });
    };
}
